<script>
export default {
	props: [
		'href',
		'buttonOnly',
		'target',
		'tag',
		'inline',
	],
	render(h) {
		const rootTag = this.tag || 'a';
		const rootData = {
			attrs: {
				class: 'ro-read-more',
			},
		};

		if (this.href) {
			rootData.attrs.href = this.href;
			rootData.attrs.target = this.target;
		}

		const buttonContent = [
			h('sky-svg', {
				props: {
					name: 'arrow',
				},
			}),
		];

		const slotContent = h('span', [
			h('div', this.$slots.default),
		]);

		const rootContent = [];

		if (!this.buttonOnly) {
			this.inline === true
				? buttonContent.unshift(slotContent)
				: rootContent.unshift(slotContent);
		}

		rootContent.push(h('button', {
			class: this.inline === true ? 'ro-read-more-inline' : '',
		}, buttonContent));

		return h(rootTag, rootData, rootContent);
	},
};
</script>

<style src="./RoReadMore.scss"></style>



// WEBPACK FOOTER //
// RoReadMore.vue?6ee7741c